import { Title } from '@bancobarigui/barihaus';
import { ReactNode } from 'react';

interface PageSectionHeaderProps {
  icon: ReactNode;
  title: string;
  description?: string;
}

export function PageSectionHeader({ icon, title, description }: PageSectionHeaderProps) {
  return (
    <>
      <div className="flex items-start mb-6">
        <div className="text-blue-500 mr-3 text-2xl">{icon}</div>
        <Title level={4} className="mt-1">
          {title}
        </Title>
      </div>
      {description && (
        <p className="text-gray-500 dark:text-gray-400 mb-6">{description}</p>
      )}
    </>
  );
}
